var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.appClass,attrs:{"id":"app"}},[_c('a',{staticClass:"skip-link",attrs:{"href":"#main-content"}},[_vm._v("Jump to main content")]),_c('SiteHeader',{attrs:{"loading":_vm.loading}}),_c('router-view',{attrs:{"id":"main-content"}}),_c('SiteFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }